const getDefaultFiltersParams = (lang: string, additionalFilterParams?: string): string =>
  `lang:${lang}${additionalFilterParams || ''}`;

const Helpers = {
  getDefaultFiltersParams,
};

export default Helpers;
